import React from 'react';
import { Grid, Typography } from '@mui/material';
const Footer = () => {
    return (
        <>
            <Grid
                md={12}
                item
                sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#2196F3', overflow: 'hidden' }}
            >
                <Typography fontSize={12} color="#fff" textAlign="center">
                    © 2024 Triunfo | Desenvolvido por BW Tecnologia
                </Typography>
            </Grid>
        </>
    );
};

export default Footer;
